import { TopListingPrices } from '@smg-real-estate/toplisting-prices';
import {
  PRICE_PREMIUM_LISTING_CHF_CENTS,
  PRICE_TOP_LISTING_BUY_CHF_CENTS,
  PRICE_TOP_LISTING_RENT_CHF_CENTS,
  WINCASA_PRICE_PREMIUM_LISTING_CHF_CENTS,
  WINCASA_PRICE_TOP_LISTING_BUY_CHF_CENTS,
  WINCASA_PRICE_TOP_LISTING_RENT_CHF_CENTS,
  WINCASA_SPECIAL_PRICING_CUSTOMER_IDS,
} from '@smg-real-estate/toplisting-prices/dist/constants';

/**
 * Converts a price in cents to CHF.
 * @param chfCents - The price in cents.
 * @returns The price in CHF rounded to two decimal places.
 */
function convertChfCentsToChf(chfCents: number): number {
  return roundToTwoDecimalPlaces(chfCents / 100);
}

/**
 * Gets the daily top listing prices
 * @param customerId - Optional customer identifier for special pricing
 * @returns An object containing the top listing prices
 */
export function getTopListingPrices_OLD(customerId?: string): TopListingPrices {
  let rentPriceCents = PRICE_TOP_LISTING_RENT_CHF_CENTS;
  let buyPriceCents = PRICE_TOP_LISTING_BUY_CHF_CENTS;
  let premiumPriceCents = PRICE_PREMIUM_LISTING_CHF_CENTS;

  // If customerId is in the list of special customer ids, use Wincasa special pricing
  if (customerId && WINCASA_SPECIAL_PRICING_CUSTOMER_IDS.includes(customerId)) {
    rentPriceCents = WINCASA_PRICE_TOP_LISTING_RENT_CHF_CENTS;
    buyPriceCents = WINCASA_PRICE_TOP_LISTING_BUY_CHF_CENTS;
    premiumPriceCents = WINCASA_PRICE_PREMIUM_LISTING_CHF_CENTS;
  }

  return {
    priceTopListingRentChf: convertChfCentsToChf(rentPriceCents),
    priceTopListingRentChfCents: rentPriceCents,
    priceTopListingBuyChf: convertChfCentsToChf(buyPriceCents),
    priceTopListingBuyChfCents: buyPriceCents,
    pricePremiumListingChf: convertChfCentsToChf(premiumPriceCents),
    pricePremiumListingChfCents: premiumPriceCents,
  };
}

/**
 * Rounds a positive number to two decimal places.
 * @param positiveNumber - The number to round.
 * @returns The number rounded to two decimal places.
 * @throws Will throw an error if the number is negative.
 */
export function roundToTwoDecimalPlaces(positiveNumber: number): number {
  if (positiveNumber === 0) {
    return 0;
  }

  if (positiveNumber < 0) {
    throw new Error('Only positive numbers are allowed');
  }

  return Math.round((positiveNumber + Number.EPSILON) * 100) / 100;
}
